import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutBrand from './components/AboutBrand';
import AboutStats from './components/AboutStats';
import AboutMilestones from './components/AboutMilestones';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <AboutBrand />
        <AboutStats />
        <AboutMilestones />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于吃瓜网黑料',
            description: '吃瓜网黑料——51吃瓜网黑料网站旗下核心内容平台，聚焦网红塌房、黑料合集与国产精品爆料内容。',
            url: 'http://yy3uj.cn/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜网黑料',
              url: 'http://yy3uj.cn/',
            },
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '吃瓜网黑料',
            url: 'http://yy3uj.cn/',
            description: '吃瓜网黑料——聚焦51吃瓜网黑料网站的热门资源与吃瓜网黑料国产精品合集。',
            email: 'hello@yy3uj.cn',
            foundingDate: '2024',
            sameAs: ['http://yy3uj.cn/'],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'http://yy3uj.cn/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '吃瓜网黑料是什么平台？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '吃瓜网黑料是51吃瓜网黑料网站旗下的核心内容平台，专注追踪网红塌房现场、整理黑料合集与国产精品爆料内容，为网友提供一手博主反差视频与网红塌房快讯。',
                },
              },
              {
                '@type': 'Question',
                name: '如何向吃瓜网黑料提供爆料线索？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过我们的爆料邮箱 hello@yy3uj.cn 或微信公众号"吃瓜网黑料"提交线索。我们会对所有线索进行核实调查，确保内容的真实性后再进行发布。',
                },
              },
              {
                '@type': 'Question',
                name: '吃瓜网黑料的内容来源可靠吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '吃瓜网黑料坚持真实爆料、理性吃瓜的原则。我们的内容团队由资深调查记者组成，所有爆料均经过多方核实与交叉验证，确保信息真实可靠。',
                },
              },
              {
                '@type': 'Question',
                name: '吃瓜网黑料支持商务合作吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '吃瓜网黑料专注于独立调查报道，暂不接受商业推广合作。我们欢迎媒体转载合作，具体事宜请通过 hello@yy3uj.cn 联系我们。',
                },
              },
              {
                '@type': 'Question',
                name: '吃瓜网黑料有哪些内容分类？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '吃瓜网黑料主要涵盖以下分类：网红塌房、黑料合集、国产精品、爆料视频、吃瓜快讯和博主黑料。每个分类都提供深度追踪报道与精品合集内容。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}